import React, { useState } from 'react'; 
import './blog-post.css'; 
import './blog-slides.css';  
//pictures here
import recap1 from './pictures/facultypanel.jpg';  

const Faculty = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
          <div className="column">
            <header>
              <h3 className="site-post-title rounded title-padding">
                <b>WiC at Work</b>
              </h3>
            </header>
            <section>
              <h2>WiC AP CSA Workshop Series</h2>
              <p className="site-post-meta">June 4, 2025</p>
              <hr />
            </section>
            <section>
              <p>

              On June 4, WiC hosted a Women in Faculty Highlight featuring an amazing panel of Allen School women faculty. The event featured a panel and small group discussion in which students were able to chat with the faculty and share their experiences. The faculty shared their computing journeys, current work, unique perspectives, and refreshing insights and advice for women navigating the computing field! ✨💻🌸

            <br></br>
            <br></br>

            Here are the faculty that were featured at the event!

            <br></br>
            <br></br>

            <strong>Natasha Jaques</strong>

            <br></br>
            <br></br>
            

            - Assistant Professor at Allen School
- Focuses on Social Reinforcement Learning research to improve AI agents 👥 💻
- Senior Research Scientist at Google DeepMind

<br></br>
<br></br>

<strong>Elba Garza</strong>

<br></br>
<br></br>

- Assistant Teaching Professor at Allen School
    - Specialized in computer architectural prediction techniques during PhD 💡 💻
- Teaches intro CSE classes!

<br></br>
<br></br>

<strong>Lauren Bricker </strong>

<br></br>
<br></br>

- Associate Teaching Professor at Allen School
- Focuses on Human-Computer Interaction and Computer Supported Collaboration and teaches Interaction Programming 📝 💻
- Awarded GeekWire STEM Educator of the Year in 2021

<br></br>
<br></br>

<strong>Rachel Lin</strong>

<br></br>
<br></br>

- Professor at Allen School
- Focuses on cryptography research and its intersections with theoretical computer science and security 🔐 💻
- Received NSF CAREER Award

<br></br>
<br></br>
              </p>
              <img src={recap1} alt="Recap 1" />
              
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faculty;